// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Bollard Buddy - Auth Modal Styles
 * Required for shared auth components
 */

/* Modal Styles - Required for auth modals */
.modal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal.hide {
  display: none !important;
}

.modal-content {
  background-color: #fff;
  margin: auto;
  padding: 0;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/bollardbuddy/styles.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,4CAA4C;AAC5C;EACE,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C","sourcesContent":["/**\n * Bollard Buddy - Auth Modal Styles\n * Required for shared auth components\n */\n\n/* Modal Styles - Required for auth modals */\n.modal {\n  position: fixed;\n  z-index: 9999;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal.hide {\n  display: none !important;\n}\n\n.modal-content {\n  background-color: #fff;\n  margin: auto;\n  padding: 0;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
